import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { PlanningNotesFormPresentation } from './planning-notes-form.presentation';
import PlanningNotesFormVM from './planning-notes-form.viewmodel';

const PlanningNotesFormContainer = withViewModel(PlanningNotesFormPresentation, ({ vm }: { vm: PlanningNotesFormVM }) => vm);

export { PlanningNotesFormContainer as PlanningNotesForm };
